import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { BreadcrumbNav, Breadcrumb } from 'excellence-ui';
import { OrganizationResponse } from '../../../../core/clients/omni-core/models';

@Component({
  selector: 'app-settings-breadcrumb-nav',
  imports: [BreadcrumbNav, Breadcrumb, RouterLink, TranslocoPipe],
  templateUrl: './settings-breadcrumb-nav.html',
})
export class SettingsBreadcrumbNav {
  organization = input.required<OrganizationResponse>();
}
